<div class="club-message" style="background: #fff;">
  <i
    class="uk-icon uk-icon-{{ iconClass }} club-message-main-icon"
    *ngIf="icon"
  ></i>
  <h3 class="m-0">{{ message }}</h3>
  <p class="m-0" *ngIf="subMessage != ''" [innerHTML]="subMessage"></p>
  <ng-content></ng-content>
</div>
